// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import React from "react";
import { Switch, Route, RouteComponentProps } from "react-router-dom";
import HomePage from "../pages/homepage/homePage";
import AdHocOcrPage from "../pages/adhococr/adhocOcrPage";
import AutoLabelModelManagementPage from "../pages/admin/autoLabelModelManagement/autoLabelModelManagement";
import ModelMetricsPage from "../pages/admin/modelMetrics/modelMetricsPage";
import AutoLabelingMetricsPage from "../pages/admin/autoLabelingMetrics/autoLabelingMetricsPage";
import OcrMetricsPage from "../pages/admin/ocrMetrics/ocrMetricsPage";
import AuthMiddleware from "./AuthMiddleware";
import FormRecognizerModelsPage from "../pages/admin/formRecognizerModels/formRecognizerModelsPage";
import AdHocOcrV2Page from "../pages/adhococrv2/adhocOcrV2Page";
import Metricsv2Page from "../pages/admin/metricsv2/metricsv2Page";
import AdHocOcrV2GroupPage from "../pages/adHocOcrV2Group/adHocOcrV2GroupPage";
import AdHocOcrV3Page from "../pages/adhococrv3/adhocOcrV3Page";
import AdHocOcrV3GroupPage from "../pages/adHocOcrV3Group/adHocOcrV3GroupPage";

/**
 * @name - Main Content Router
 * @description - Controls main content pane based on route
 */

interface MatchParams {
    name: string;
}

interface MatchProps extends RouteComponentProps<MatchParams> {
}

export function MainContentRouter() {
    return (
        <div className="app-content">
            <Switch>
                <Route path="/" exact component={HomePage} />
                <Route path="/adhococr" exact component={AdHocOcrPage} />
                <Route path="/adhococrv2" exact component={AdHocOcrV2Page} />
                <Route path="/adhococrgroup" exact component={AdHocOcrV2GroupPage} />
                <Route path="/adhococrv3" exact component={AdHocOcrV3Page} />
                <Route path="/adhococrv3group" exact component={AdHocOcrV3GroupPage} />
                <Route 
                    path="/model-sdc" 
                    exact 
                    render={(props) => (
                        <AuthMiddleware {...props} component={AutoLabelModelManagementPage} />
                    )} 
                />
                <Route 
                    path="/model-sdc/modelMetrics" 
                    exact 
                    render={(props) => (
                        <AuthMiddleware {...props} component={ModelMetricsPage} />
                    )} 
                />
                <Route 
                    path="/model-sdc/autoLabelingMetrics" 
                    exact 
                    render={(props) => (
                        <AuthMiddleware {...props} component={AutoLabelingMetricsPage} />
                    )} 
                />
                <Route 
                    path="/model-sdc/ocrMetrics" 
                    exact 
                    render={(props) => (
                        <AuthMiddleware {...props} component={OcrMetricsPage} />
                    )} 
                />                               
                <Route 
                    path="/model-sdc/formRecognizerModels" 
                    exact 
                    render={(props) => (
                        <AuthMiddleware {...props} component={FormRecognizerModelsPage} />
                    )} 
                />                               
                <Route 
                    path="/model-sdc/metricsV2" 
                    exact 
                    render={(props) => (
                        <AuthMiddleware {...props} component={Metricsv2Page} />
                    )} 
                />                               
                <Route component={HomePage} />
            </Switch>
        </div>
    );
}
